import { render } from "./WeekPickSummary.vue?vue&type=template&id=41c5db8c"
import script from "./WeekPickSummary.vue?vue&type=script&lang=ts"
export * from "./WeekPickSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script